import React, { ReactElement } from "react";
import MainImg from "./mainImg";

import SharedButton from "../sharedButton";
export default function HowIsCarWarranty(): ReactElement {
    return (
        <section className="flex flex-col lg:flex-row lg:gap-28 gap-16  lg:mt-28 mt-14  ">
            <div className="max-w-[574px]  mx-auto lg:mx-0 order-1 lg:order-2">
                <h2 className="font-bold lg:text-3xl text-2xl lg:leading-[45px] ">
                    How Is a Home Warranty Different From Homeowners' Insurance?
                </h2>
                <p className="mt-5   lg:text-lg text-base lg:leading-8  font-light">
                    While homeowners' insurance primarily covers property damage
                    and the structure of your house, a home warranty is designed
                    to provide protection for your appliances and systems. It's
                    a smart investment to ensure the safety of your home, but it
                    should not be considered a replacement for homeowners'
                    insurance. It's worth noting that manufacturer warranties
                    may provide coverage for certain home systems in the case of
                    recent home purchases.
                </p>
                <div className="lg:mt-[50px] mt-7 text-center sm:text-left">
                    <SharedButton />
                </div>
                <span className="w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"></span>
            </div>
            <div className="w-[250px] h-[250px] md:h-[402px] md:w-[400px] md:min-w-[400px] relative mx-auto  lg:mt-16 order-2 lg:order-1">
                <MainImg />
            </div>
        </section>
    );
}
